module.exports = __webpack_public_path__ + "static/media/checked-mark.f1a0e41b.svg";